import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

class PaymentCancel extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage
              id="app.paymentcancel.title"
              defaultMessage="Maksu epäonnistui"
            />
          </h1>
          <p>
            <FormattedMessage
              id="app.paymentcancel.text"
              defaultMessage="Laskun maksaminen keskeytyi."
            />
          </p>
          <Link to={"/dashboard"} className={"btn btn-primary"}>
            <FormattedMessage
              id="app.paymentsuccess.return"
              defaultMessage="Palaa etusivulle"
            />
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(store) {
  return {
    locale: store.locale,
    wordpress: store.wordpress
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentCancel);



// WEBPACK FOOTER //
// ./src/containers/Payment/Cancel.js